<template>
  <footer
    id="main-footer"
    class="bg-float-default-low text-static-default-hi relative p-32"
  >
    <div class="mx-auto lg:w-[1120px]">
      <FooterEmailCollector v-if="FF_ENABLE_FOOTER_EMAIL_COLLECTOR" />

      <ul class="flex list-none flex-col gap-32 md:flex-row">
        <li
          v-for="(column, index) in columns"
          :key="index"
          class="md:basis-full"
        >
          <FooterLinkColumn :links="column.links" :title="column.title">
            <FooterSocialIcons
              v-if="column.socials?.length"
              :socials="column.socials"
            />
            <FooterPaymentIcons
              v-if="column.payment"
              :payment="column.payment"
            />
            <FooterLogos v-if="column.logos?.length" :logos="column.logos" />
          </FooterLinkColumn>
        </li>
      </ul>

      <RevDivider class="my-20" />

      <FooterBottomBar />
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#imports'

import { RevDivider } from '@ds/components/Divider'

import FooterEmailCollector from '~/scopes/navigation/components/Footer/FooterEmailCollector/FooterEmailCollector.vue'

import { useFooterConfig } from '../composables/useFooterConfig'

import FooterBottomBar from './FooterBottomBar.vue'
import FooterLinkColumn from './FooterLinkColumn.vue'
import FooterLogos from './FooterLogos.vue'
import FooterPaymentIcons from './FooterPaymentIcons.vue'
import FooterSocialIcons from './FooterSocialIcons.vue'

const { FF_ENABLE_FOOTER_EMAIL_COLLECTOR = false } = useRuntimeConfig().public

const { columns } = useFooterConfig()
</script>
